import { get, post } from '@va/http-client';
import { isNil } from 'lodash';

export const getWebsite = (websiteId) => {
  const url = `/wix/websites/${websiteId}`;

  return get(url, {});
};

export const createWebsite = (website) => {
  const url = `/wix/websites`;

  if (isNil(website) || !Object.prototype.hasOwnProperty.call(website, 'instance')) {
    throw new Error('Website needs instance');
  }

  return post(url, {}, website);
};

export const activateDirectAccess = (websiteId, data) => {
  const url = `/migrations/websites/${websiteId}/migrate`;
  return post(url, {}, data);
};
